import axios from 'axios'
import apiList from './resource.js'

export default {
  // 股掌柜内嵌登录换令牌
  managerTicketLogin: function (data, successfn, errorfn) {
    return axios.post(apiList.common.managerTicketLogin, data)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 股掌柜内嵌退出登陆
  managerLogoutLogin: function (successfn, errorfn) {
    return axios.get(apiList.common.managerLogoutLogin)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 是否有绑电话
  orVerifyMobile: function (successfn, errorfn) {
    return axios.get(apiList.common.verifyMobile)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 修改绑定手机号码
  editMobile: function (data, successfn, errorfn) {
    return axios.post(apiList.common.editMobile, data)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 埋点
  collect: function (data, successfn, errorfn) {
    return axios
      .post(apiList.common.collect, data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 数据字典查询
  getDict: function (data, successfn, errorfn) {
    return axios
      .get(apiList.common.dictionary, {
        params: data
      })
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 客户端人数统计
  postStatistics: function (data, successfn, errorfn) {
    return axios
      .post(apiList.common.statistics, data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 获取公告详情
  getNotice: function (successfn, errorfn) {
    return axios.get(apiList.common.getNotice)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // wx-jssdk验证
  wxJssdkCheck: function (data, successfn, errorfn) {
    return axios.post(apiList.common.wxconfig, data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  }
}



// WEBPACK FOOTER //
// ./src/fetch/common.js